module.exports = __webpack_public_path__ + "img/logo_aeoh.d4a3a688.png";